import PropTypes from 'prop-types';

export const appRequestPrimarySearchPropTypes = {
	appId: PropTypes.number.isRequired,
	changeHandler: PropTypes.func,
	name: PropTypes.string,
	label: PropTypes.string,
};
